import { Empty, PageHeader, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { PlusCircleFilled,EyeOutlined } from "@ant-design/icons";


moment.locale("es");

class Sesiones extends Component {
  state = {
    modalAgregar: false,
    modalver: false,
    todasSesiones: [],
    loading: false,
    cajaId: null,
  };

  // Abrir modal para agregar
  abrirAgregarSesion() {
    this.setState({ modalAgregar: true, SesionId: null });
  };

  // Cerrar modal de agregar
  cerrarAgregarSesion() {
    this.setState({ modalAgregar: false });
    this.consultarTodasSesiones();
  };

  // Abrir modal para editar
  abrirVerSesion(sesionId) {
    this.props.history.push(`/panel/verSesion/${sesionId}`);
  }

  // Cerrar modal de editar
  cerrarVerSesion() {
    this.setState({ modalEditar: false });
    this.consultarTodasSesiones();
  };

  componentDidMount() {
    this.consultarTodasSesiones();
  }

  consultarTodasSesiones() {
    this.setState({ loading: true });
    axios
      .post(
        "sesionesPV/selectSesionesPV",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            todasSesiones: res.data.sesiones
          });
        } else {
          message.error("Error no se encotraron Sesiones");
        }
      });
  }

  abrirSesion(sesionId) {
    const relativeUrl = `/puntoDeVenta/${sesionId}`;
    const fullUrl = window.location.origin + relativeUrl;
    window.open(fullUrl, '_blank');
  }



  render() {
    const columns = [
      {
        title: "Caja",
        dataIndex: "cajaNombre",
        key: "cajaNombre",
      },
      {
        title: "Fecha Inicial",
        dataIndex: "fechaInicial",
        key: "fechaInicial",
        render: (fecha) => moment(fecha).format("DD/MM/YYYY HH:mm"),
      },
      {
        title: "Fecha Final",
        dataIndex: "fechaFinal",
        key: "fechaFinal",
        render: (fecha) =>
          fecha
            ? moment(fecha).format("DD/MM/YYYY HH:mm")
            : "En Curso",
      },

      {
        title: "Acción",
        key: "accion",
        align: "center",
        width: "25%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (record, index) => {
          let buttons = [];

     
          const puedeVer = true;
          buttons.push(
            <Tooltip 
              title={puedeVer ? "Ver Sesión" : "No disponible"} 
              placement="top" 
              overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
            >
              <ButtonItem
                key={`ver-${index}`}
                type="default"
                size="small"
                azul
                icon={<EyeOutlined />}
                onClick={() => puedeVer && this.abrirVerSesion(record._id)}
                disabled={!puedeVer}
              >
              </ButtonItem>
            </Tooltip>
          );

          const puedeAbrirCaja = !record.fechaFinal;
          buttons.push(
            <Tooltip 
              title={puedeAbrirCaja ? "Abrir Caja" : "Sesión cerrada"} 
              placement="top" 
              overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
            >
              <ButtonItem
                key={`abrir-${index}`}
                type="default"
                size="small"
                naranja
                icon={<PlusCircleFilled />}
                onClick={() => puedeAbrirCaja && this.abrirSesion(record._id)}
                disabled={!puedeAbrirCaja}
              >
              </ButtonItem>
            </Tooltip>
          );

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];




    return (
      <>
        <PageHeader
          title="Sesiones"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}

        />
        <TableItem
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <>
                    <p>
                      No hay registros de Sesiones. Aquí puedes gestionar y
                      llevar un control de las Sesiones.
                    </p>
                  </>
                }
              />
            ),
          }}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasSesiones}
          columns={columns}
          pagination={false}
        />

      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(Sesiones);
